export default {
    'first_name'               : 'First name',
    'last_name'                : 'Last name',
    'country'                  : 'Country',
    'phone'                    : 'Mobile phone',
    'email'                    : 'Email',
    'email_confirmation'       : 'Confirm email',
    'address_primary'          : 'Primary Address',
    'city'                     : 'City',
    'state'                    : 'State',
    'zip'                      : 'Zip',
    'province'                 : 'Province',
    'additional_info'          : 'Province',
    'postal_code'              : 'Postal code',
    'is_international_customer': 'Is International customer?',
}
